import { Component, inject, OnInit } from '@angular/core';
import { AlertService } from '../services/alert';
import { Auth } from '../services/auth';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  providers: [AlertService],
  imports: [ReactiveFormsModule],
  //template: `
  //  <button (click)="login()">Login</button>
  //`,
  templateUrl: './login.html',
  styleUrl: './login.css'

})

export class Login implements OnInit 
{
  currentAlert: any;
  result = "";
  private router = inject(Router);

  constructor(
    private alertService: AlertService,
    private auth: Auth
  ) {}

  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });

  login()
  {

    this.auth.login(this.loginForm.controls['username'].value, this.loginForm.controls['password'].value).subscribe(response=> 
    {
      this.result = JSON.stringify(response);
      if (response.status == "error")
      {
        this.showSnackbar(response.message);  
      }
      else
      {
        this.router.navigate(['/home']);
      }

    },
    error=>
    {
      this.showSnackbar('Login Error: '+error.message+ ' - '+error.statusText);
      //let e = error;
      this.result = 'Login Error: '+error.message+ ' - '+error.statusText;
    });

  }
  
  showSnackbar(message:string) {
    //alert._snackBar.open(message, 'Dismiss', {
    //duration: 3000, // Duration in milliseconds
    this.alertService.showSnackbar(message);
  };

  ngOnInit(): void {
    };
  }
